<template>
  <div>
    <select
      class=" form-select form-select-sm"
      v-model="selectedResolution"
      @change="setResolutionConfirmation"
    >
      <option selected value="">Resolve Via</option>
      <option
        v-for="resolution in resolutionList"
        :key="resolution.action"
        :value="resolution.action"
        :title="resolution.toolTip"
      >
        {{ resolution.label }}
      </option>
    </select>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="setResolutionOption"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import resolutionOptions from "@/config/resolution-options.json";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ItemResolution",
  props: {
    itemId: {
      required: true,
      type: String,
    },
    choice: {
      required: false,
      type: String,
    },
    isPermitted: {
      required: false,
      type: Boolean,
      default: true,
    }
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  data() {
    return {
      selectedResolution: "",
      setting: false
    };
  },
  computed: {
    resolutionList() {
      if (!this.isPermitted)
        return resolutionOptions.filter((data) => {
          return !(!this.isPermitted && data.action == "NewBarrel");
        });
      return resolutionOptions;
    },
  },
  methods: {
    async setResolutionConfirmation() {
      if(!this.selectedResolution) return;
      const resolutionLabel = this.getResolutionOptionText(this.selectedResolution) ?? this.selectedResolution;


      this.showConfirmationModal({
        title: `Confirm selection`,
        message: `Are you sure you want this item resolved via<b><em> ${resolutionLabel}</em></b>?`,
      });
    },
    getResolutionOptionText(option){
      if(!option) return "";

      return this.resolutionList.find(r => r.action === option)?.label ?? "";
    },
    async setResolutionOption() {
      try {
        this.setting = true;
        this.startConfirmationLoading();
        let result = await ApiService.Instance.setCustomerItemOption({
          option: this.selectedResolution,
          itemId: this.itemId,
        });
        if (result) {
          this.showNotifier({
            message: `Successfully made submission`,
            snackbarType: "success",
          });
          this.$emit("updated");
        }
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed to make submission`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
      this.setting = false;
    },
  },
});
</script>

<style></style>
